import EventTeaser from 'components/Teasers/Event'
import CustomCard from 'components/Teasers/Event/CustomCard'
import styles from './List.module.scss'

export default function List({ events, linkParam = null }) {
  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.wrap}>
          {events.length > 0 &&
            events.map((event) =>
              !event.type && !('ad_position' in event) ? (
                <EventTeaser
                  key={event.id}
                  event={event}
                  linkParam={linkParam}
                />
              ) : (
                <CustomCard
                  header={event.text_primary}
                  subheader={event.text_secondary}
                  ctaText={'Tutustu!'}
                  link={event.url}
                  image={event.image.filename}
                  adId={event.id}
                  key={event.id}
                />
              ),
            )}
        </div>
        {events.length === 0 && (
          <h6 className="text-center">
            Ei tuloksia. Kokeile muuttaa hakuehtoja.
          </h6>
        )}
      </div>
    </section>
  )
}
